import { createClient } from "@/app/utils/supabase/client";
import { Customer, CustomerInsert, CustomerUpdate } from "@/app/lib/supabase/types";
import { SUPABASE_TABLES } from "@/app/lib/supabase/supabaseDBConstants";

export const customersApi = {
  async getCustomers(companyId: string): Promise<Customer[]> {
    const supabase = createClient();
    
    const { data, error } = await supabase
      .from(SUPABASE_TABLES.CUSTOMERS)
      .select("*")
      .eq("company_id", companyId)
      .is("deleted_at", null)
      .order("name", { ascending: true });

    if (error) {
      console.error("Error fetching customers:", error);
      throw error;
    }

    return data || [];
  },

  async getCustomer(customerId: string): Promise<Customer> {
    const supabase = createClient();
    
    const { data, error } = await supabase
      .from(SUPABASE_TABLES.CUSTOMERS)
      .select("*")
      .eq("id", customerId)
      .is("deleted_at", null)
      .single();

    if (error) {
      console.error("Error fetching customer:", error);
      throw error;
    }

    if (!data) {
      throw new Error("Customer not found");
    }

    return data;
  },

  async createCustomer(customer: CustomerInsert): Promise<Customer> {
    const supabase = createClient();
    
    const { data, error } = await supabase
      .from(SUPABASE_TABLES.CUSTOMERS)
      .insert(customer)
      .select()
      .single();

    if (error) {
      console.error("Error creating customer:", error);
      throw error;
    }

    return data;
  },

  async updateCustomer(customerId: string, updates: CustomerUpdate): Promise<Customer> {
    const supabase = createClient();
    
    const { data, error } = await supabase
      .from(SUPABASE_TABLES.CUSTOMERS)
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq("id", customerId)
      .select()
      .single();

    if (error) {
      console.error("Error updating customer:", error);
      throw error;
    }

    return data;
  },

  async deleteCustomer(customerId: string): Promise<void> {
    const supabase = createClient();
    
    const { error } = await supabase
      .from(SUPABASE_TABLES.CUSTOMERS)
      .update({ 
        deleted_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      })
      .eq("id", customerId);

    if (error) {
      console.error("Error deleting customer:", error);
      throw error;
    }
  },
};